import React, { useEffect, useRef, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import './dashboard.scss'
import moment from 'moment';
import GaugeComponent from 'react-gauge-component';
import { io } from "socket.io-client";
import BarChart from './Barchart';
import LineChart from './LineChart';
import HorizontalBarChart from './HorizontalChart';
import AchievedTargetBar from './AchievedTarget/AchievedTarget';
import DonutChart from './DonutChart';
import happilogo from "../../assets/happi_h_logo.png"


const socket = io("https://mis-api.happimobiles.com", { withCredentials: true, });



const Sales = ({data}) => {
  const [avialableheight, setAvailableHeight] = useState(0);
  const [socketStatus, setSocketStatus] = useState("init");
  const [regionWiseData,setRegionWiseData]=useState([])
  const [chartsData, setChartsData] = useState({
    gross_profit:501687,net_profit:-1104635,
    sale_qty:372,
    sale_value:3390810,
    total_discount:83341,
  });
  const [achievedTargetData, setAchievedTragetData] = useState([]);
  const [donutData,setDonutData]=useState([]);
  const [asmChartData,setAsmchartsData]=useState([])
  let BASE_URL = 'https://mis-api.happimobiles.com'


 
  useEffect(() => {
    getData();
    AchievedvsTargetData();
    getDonutData();
    asmAchievedvsTargetData();
    getRegionWiseData();

  }, [data])


  const getData = async () => {
    if (!data) return
    let statevalue = data?.state?.value || 0;
    let asmValue = data?.asm?.value || 0;
    let storeValue = data?.store?.value || 0
    if(data?.state?.value=="All"){
      statevalue = 0;
      asmValue = 0;
      storeValue=0;
    }
    if(data?.state?.value&&(!storeValue&&!asmValue)){
      asmValue = 0;
      storeValue=0;
    }
    if(data?.store?.value) {
      statevalue = 0;
      asmValue = 0;
    }
    if (data?.asm?.value) {
      statevalue = 0;
    }
    let payload = {
      statehead: statevalue,
      asm: asmValue,
      store: storeValue,
    };
    let url;
     if(data?.customdates) url=`${BASE_URL}/api/tvDashboard/dashBoardCards?type=${data.type.toLowerCase()}&from=${data.customdates.startdate.split('T')?.[0]}&to=${data.customdates.endDate.split('T')?.[0]}`
    else url=`${BASE_URL}/api/tvDashboard/dashBoardCards?type=${data.type.toLowerCase()}`
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(payload)
    });
    let result = await response.json();
    setChartsData(result)
  }

  const getDonutData=async ()=>{
    if (!data) return
    let statevalue = data?.state?.value || 0;
    let asmValue = data?.asm?.value || 0;
    let storeValue = data?.store?.value || 0
    if(data?.state?.value=="All"){
      statevalue = 0;
      asmValue = 0;
      storeValue=0;
    }
    if(data?.state?.value&&(!storeValue&&!asmValue)){
      asmValue = 0;
      storeValue=0;
    }
    if(data?.store?.value) {
      statevalue = 0;
      asmValue = 0;
    }
    if (data?.asm?.value) {
      statevalue = 0;
    }
    let payload = {
      statehead: statevalue,
      asm: asmValue,
      store: storeValue,
    };
    let url;
    if(data?.customdates) url=`${BASE_URL}/api/tvDashboard/getBrandWiseProfit?type=${data.type.toLowerCase()}&from=${data.customdates.startdate.split('T')?.[0]}&to=${data.customdates.endDate.split('T')?.[0]}`
    else url=`${BASE_URL}/api/tvDashboard/getBrandWiseProfit?type=${data.type.toLowerCase()}`
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(payload)
    });
    let result = await response.json();
    setDonutData(result)
   
// console.log("resul-donut",result)
    // setChartsData(result)
    
  }

  const AchievedvsTargetData = async () => {
    if (!data) return
    let statevalue = data?.state?.value || 0;
    let asmValue = data?.asm?.value || 0;
    let storeValue = data?.store?.value || 0
    if(data?.state?.value=="All"){
      statevalue = 0;
      asmValue = 0;
      storeValue=0;
    }
    if(data?.state?.value&&(!storeValue&&!asmValue)){
      asmValue = 0;
      storeValue=0;
    }
    if(data?.store?.value) {
      statevalue = 0;
      asmValue = 0;
    }
    if (data?.asm?.value) {
      statevalue = 0;
    }
    let payload = {
      statehead: statevalue,
      asm: asmValue,
      store: storeValue,
    };
    let url;
     if(data?.customdates) url=`${BASE_URL}/api/tvDashboard/getTargetAndAchieved?type=${data.type.toLowerCase()}&from=${data.customdates.startdate.split('T')?.[0]}&to=${data.customdates.endDate.split('T')?.[0]}`
    else url=`${BASE_URL}/api/tvDashboard/getTargetAndAchieved?type=${data.type.toLowerCase()}`
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(payload)
    });
    let result = await response.json();
    // console.log("result", result)
    setAchievedTragetData(result)
    if (result?.status) {
      // localStorage.setItem("data",JSON.stringify(result.data))
      // console.log("result", result)
      // setChartsData(result.data)
    }
  }

  const asmAchievedvsTargetData = async () => {
    if (!data) return
    let statevalue = data?.state?.value || 0;
    let asmValue = data?.asm?.value || 0;
    let storeValue = data?.store?.value || 0
    if(data?.state?.value=="All"){
      statevalue = 0;
      asmValue = 0;
      storeValue=0;
    }
   if(data?.state?.value&&(!storeValue&&!asmValue)){
      asmValue = 0;
      storeValue=0;
    }
    if(data?.store?.value) {
      statevalue = 0;
      asmValue = 0;
    }
    if (data?.asm?.value) {
      statevalue = 0;
    }
    let payload = {
      statehead: statevalue,
      asm: asmValue,
      store: storeValue,
    };
    let url;
     if(data?.customdates) url=`${BASE_URL}/api/tvDashboard/getASMTargetAndAchieved?type=${data.type.toLowerCase()}&from=${data.customdates.startdate.split('T')?.[0]}&to=${data.customdates.endDate.split('T')?.[0]}`
    else url=`${BASE_URL}/api/tvDashboard/getASMTargetAndAchieved?type=${data.type.toLowerCase()}`
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(payload)
    });
    let result = await response.json();
    console.log("result---asmmmm", result)
    setAsmchartsData(result)
    // setAchievedTragetData(result)?
  }

  const getRegionWiseData=async()=>{
    if (!data) return
    let statevalue = data?.state?.value || 0;
    let asmValue = data?.asm?.value || 0;
    let storeValue = data?.store?.value || 0
    if(data?.state?.value=="All"){
      statevalue = 0;
      asmValue = 0;
      storeValue=0;
    }
    if(data?.state?.value&&(!storeValue&&!asmValue)){
      asmValue = 0;
      storeValue=0;
    }
    if(data?.store?.value) {
      statevalue = 0;
      asmValue = 0;
    }
    if (data?.asm?.value) {
      statevalue = 0;
    }
    let payload = {
      statehead: statevalue,
      asm: asmValue,
      store: storeValue,
    };
    let url;
     if(data?.customdates) url=`${BASE_URL}/api/tvDashboard/getRegionWiseTargetAndAchieved?type=${data.type.toLowerCase()}&from=${data.customdates.startdate.split('T')?.[0]}&to=${data.customdates.endDate.split('T')?.[0]}`
    else url=`${BASE_URL}/api/tvDashboard/getRegionWiseTargetAndAchieved?type=${data.type.toLowerCase()}`
    let response = await fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(payload)
    });
    let result = await response.json();
    console.log("regionwiseData", result);
    setRegionWiseData(result)
    // setAsmchartsData(result)
  }


  let mapdata = [{
    name: 'Achieved',
    data: achievedTargetData.slice(0,10).map(item => ({
      x: item?.branch_name,
      y: item?.profit,
      goals: [
        {
          name: "target",
          value: item?.target,
          strokeHeight: 5,
          strokeColor: '#775DD0'
        }
      ]
    }))
  }]

  let maxValue=achievedTargetData.slice(0, 10).map(item=>item?.target);
  let maxProfit=achievedTargetData.slice(0, 10).map(item=>item?.profit)

  let mapExpectedAchievedData=achievedTargetData.slice(0,10).map(item=>({profit:item.profit,target:item.target,branch:item.branch_code}))
  // console.log("mapdata", mapdata)
  const [series] = useState([
    {
      name: 'Achieved',
      data: [
        { x: '2011', y: 1292, goals: [{ name: 'Expected', value: 1400, strokeHeight: 5, strokeColor: '#775DD0' }] },
        { x: '2012', y: 4432, goals: [{ name: 'Expected', value: 5400, strokeHeight: 5, strokeColor: '#775DD0' }] },
        { x: '2013', y: 5423, goals: [{ name: 'Expected', value: 5200, strokeHeight: 5, strokeColor: '#775DD0' }] },
        { x: '2014', y: 6653, goals: [{ name: 'Expected', value: 6500, strokeHeight: 5, strokeColor: '#775DD0' }] },
        { x: '2016', y: 7132, goals: [{ name: 'Expected', value: 7500, strokeHeight: 5, strokeColor: '#775DD0' }] },
        { x: '2017', y: 7332, goals: [{ name: 'Expected', value: 8700, strokeHeight: 5, strokeColor: '#775DD0' }] },
        { x: '2018', y: 6553, goals: [{ name: 'Expected', value: 7300, strokeHeight: 2, strokeDashArray: 2, strokeColor: '#775DD0' }] }
      ]

    }
  ]);
  //  const [series] = useState( [
  //   {
  //     name: 'Achieved',
  //     data: [
  //       { x: 'Ammerpet', y: 1292},
  //       { x: 'Punjagutta', y: 4432},
  //       { x: 'S.R Nagar', y: 5423},
  //       { x: 'Madhapur', y: 6653 },
  //       { x: 'KPHB', y: 8133},
  //       { x: 'Tanuku', y: 7132 },
  //       { x: 'Bhimavaram', y: 7332 },
  //       { x: 'Hitech', y: 6553 }
  //     ]
  //   },
  //   {
  //     name: 'Target',
  //     data: [
  //       { x: 'Ammerpet', y: 1400,color:'blue'},
  //       { x: 'Punjagutta', y: 5400,color:'blue' },
  //       { x: 'S.R Nagar', y: 5200,color:'blue' },
  //       { x: 'Madhapur', y: 6500,color:'blue' },
  //       { x: 'KPHB', y: 6600,color:'blue'},
  //       { x: 'Tanuku', y: 7500,color:'blue' },
  //       { x: 'Bhimavaram', y: 8700,color:'blue' },
  //       { x: 'Hitech', y: 7300,color:'blue' }
  //     ]
  //   }
  // ]);


  const options = {
    chart: {
      height: "100%",
      type: 'bar',
      toolbar: {
        show: false
      }
    },

    plotOptions: {
      bar: {
        columnWidth: '60%'
      }
    },

    colors: ['#00E396'],
    dataLabels: {
      enabled: true, // Enable data labels on the bars
      style: {
        fontSize: '12px', // Adjust the font size
        fontWeight: 'bold', // Make the text bold
        colors: ['#ffffff'] // Text color (white)
      },
      background: {
        enabled: true, // Show background behind the text
        foreColor: '#000000', // Background color
        borderRadius: 4, // Rounded corners for background
        padding: 4, // Padding around the text
        opacity: 0.7 // Opacity of the background
      },
      offsetY: -10, // Adjust position of the data label above the bar
      dropShadow: {
        enabled: true, // Enable drop shadow to make text stand out
        blur: 3,
        left: 1,
        top: 1
      }
    },
    legend: {
      show: true,
      showForSingleSeries: true,
      customLegendItems: ['Achieved', 'Target'],
      markers: {
        fillColors: ['#775DD0', '#00E396']
      }
    },
    yaxis: {
      min: 1000,  // Custom minimum value for the y-axis
      max: Math.round(Math.max(...maxValue)),  // Custom maximum value for the y-axis
      tickAmount: 4,  // Number of ticks between min and max
      axisTicks: {
        show: true,
        borderType: 'solid',
        color: '#78909C',
        width: 6,
        offsetX: 0,
        offsetY: 0
      },
      title: {
        text: "Achieved vs Target Graph",
        rotate: -90,
        offsetX: 0,
        offsetY: 0,
        style: {
          color: "red",
          fontSize: '12px',
          fontFamily: 'Helvetica, Arial, sans-serif',
          fontWeight: 600,
          cssClass: 'apexcharts-yaxis-title',
        },
      },

    },
  };

  const positiveNegativeValueSeries = [
    {
      name: 'Cash Flow',
      data: asmChartData.slice(0, 10).map(item => item.total_profit)
    }
  ];

  const positiveNegativeValueSeriesOptions = {
    chart: {
      type: 'bar',
      height: "33%",
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false,
      },
    },

    plotOptions: {
      bar: {
        colors: {
          ranges: [
            {
              from: 0,
              to: Number.MAX_VALUE, // Positive values
              color: '#00FF00' // Positive color (green)
            },
            {
              from: -Number.MAX_VALUE,
              to: -1, // Negative values
              color: '#FF0000' // Negative color (red)
            }
          ]
        },
        columnWidth: '80%'
      }
    },
    dataLabels: {
      enabled: false
    },
    yaxis: {

      axisTicks: {
        show: true,
        borderType: 'solid',
        color: '#78909C',
        width: 6,
        offsetX: 0,
        offsetY: 0
      },
      labels: {
        formatter: function (y) {
          return y.toFixed(0);
        }
      }
    },

    xaxis: {
      categories:asmChartData.slice(0,10).map(item=>item.asm),
      labels: {
        rotate: -90
      }
    }
  };

  const scrollContainerRef = useRef(null); // For managing scroll of the entire dashboard container
  const [isTop, setIsTop] = useState(true);
  const [isBottom, setIsBottom] = useState(false);

  // Update button states based on scroll position
  const updateButtonState = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      setIsTop(container.scrollTop === 0);
      setIsBottom(container.scrollHeight - container.scrollTop === container.clientHeight);
    }
  };

  // Scroll up by a small amount
  const scrollTop = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        top: -50,
        behavior: "smooth",
      });
    }
  };

  // Scroll down by a small amount
  const scrollBottom = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        top: 50,
        behavior: "smooth",
      });
    }
  };
  useEffect(() => {
    socket.on("connect", () => {
      console.log(socket.id, "connetcted");
    });
    let localUid=localStorage.getItem('uuid');
    socket.on('scroll', (data) => {
      if(data?.uuid==JSON.parse(localUid)){
        if(data=="up") scrollTop()
          if(data=="down") scrollBottom()
      }
     
      // setData(data)
    })
    socket.on("error", (error) => {
      console.log("erorrr")
      // console.log(socket.id,"dissss"); 
    });
    socket.on("disconnect", () => {
      console.log(socket.id, "dissss"); 
    });
    return () => {
      socket.off("message");
    };

  }, []);

  // Add event listener to check scroll position
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", updateButtonState);
    }
    return () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.removeEventListener("scroll", updateButtonState);
      }
    };
  }, []);







  const donutvalues = donutData.map(item=>item.profit);
  const donutLabels = donutData.map(item => item.brand_name);

  const donutOptions ={
    chart: {
      width: 380,
      type: 'pie',
    },
    labels: donutLabels,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  }


  let colors = new Array({ length: 8 }).fill("red")
  const barChartValues = [{
    data: asmChartData.map(item=>-item.total_profit)
  }];
  const barChartOptions = {
    chart: {
      height: "100%",
      type: 'bar',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false,
      },
    },

    colors: colors,
    plotOptions: {
      bar: {
        columnWidth: '45%',
        distributed: true,
      }
    },
    dataLabels: {
      enabled: false
    },
    legend: {
      show: false
    },
    xaxis: {
      categories:asmChartData.map(item=>item.asm),
      labels: {
        style: {
          colors: colors,
          fontSize: '12px'
        }
      }
    }
  }

  const currencyFormatter = (price) => {
    let rupee = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    })
    return rupee.format(price)
  }

  return (
    <>
      <div className='d-container' >
        <div className='containerbg position-relative'>
          <h5 className='text-center sales-title m-0'>Happi Sales Dashboard</h5>
          <img src={happilogo} alt="logo" height={"24px"} width={"30px"} className='position-absolute logo-img'/>
        </div>
      </div>
      <div className='d-flex gap-4 data-container' ref={scrollContainerRef} style={{ height: "100vh",overflowY: "auto"  }}>
        <div className='width-class'>
         
            <div className='mb-2 filter-container'>
            <div className='d-flex justify-content-around'>
            <div className='sidemenu-items'>
            <div className='d-flex flex-column justiy-content-center'>
              <p className='amount-text m-0'><span className='label'>Type:</span>{data?.type}</p>
              <p className='amount-text m-0'><span className='label'>State: </span>{data?.state?.label} <span className='label'>ASM:</span>{data?.asm?.label}</p>
              <p className='amount-text m-0'><span className='label'>Store:</span>{data?.store?.label}</p>
              {data?.customdates&&<p className='amount-text m-0'><span className='label'>Start Date:</span>{moment(new Date(new Date(data?.customdates?.startdate).getTime()-86400000)).format('ll')} <span className='label'>End Date:</span>{moment(new Date(new Date(data?.customdates?.endDate).getTime()-86400000)).format('ll')}</p>}
            </div>

          </div>
          <div className='sidemenu-items'>
            <div className='d-flex flex-column justiy-content-center align-items-center'>
              <p className='m-0'>{currencyFormatter(chartsData?.gross_profit)}</p>
              <p className='amount-text m-0'>Gross</p>
            </div>

          </div>
          <div className='sidemenu-items'>
            <div className='d-flex flex-column justiy-content-center align-items-center'>

              <p className='m-0' >{currencyFormatter(chartsData?.total_discount)}</p>
              <p className='amount-text m-0'>Discount</p>
            </div>


          </div>
          <div className='sidemenu-items'>
            <div className='d-flex flex-column justiy-content-center align-items-center'>

              <p className='m-0'>{currencyFormatter(chartsData?.net_profit)}</p>
              <p className='amount-text m-0'>Net</p>
            </div>


          </div>
          <div className='sidemenu-items'>
          <div className='d-flex flex-column justiy-content-center align-items-center'>

<p className='m-0'>{currencyFormatter(chartsData?.sale_value)}</p>
<p className='amount-text m-0'>Total Sale</p>
</div>
          </div>
          <div className='sidemenu-items'>
          <div className='d-flex flex-column justiy-content-center align-items-center'>

<p className='m-0'>{currencyFormatter(chartsData?.sale_qty)}</p>
<p className='amount-text m-0'>Quantity Sold</p>
          </div>
         
          </div>
        </div>
            </div>
          

          <div className='row mt-2'>

            <div className='col-md-4 bxstv'>
            {/* <HorizontalBarChart/> */}
            <h4 className='text-center fs-6 m-0'>ASM Wise Profit</h4>
          <ReactApexChart options={positiveNegativeValueSeriesOptions} series={positiveNegativeValueSeries} type="bar"/>

              {/* <ReactApexChart options={barChartOptions} series={barChartValues} type="bar" /> */}

            </div>
            <div className='col-md-8 bxstv actual-expected-chart'>
            {/* <AchievedTargetBar chartdata={mapExpectedAchievedData}/> */}
             
              <ReactApexChart options={options} series={mapdata} type="bar"/>

            </div>
          </div>

          <div className='row mt-2'>
            <div className='col-md-5'>
            <LineChart chardata={regionWiseData}/>
              {/* <BarChart chartdata={mapExpectedAchievedData}/> */}
              {/* <ReactApexChart options={positiveNegativeValueSeriesOptions} series={positiveNegativeValueSeries} type="bar" height={"100%"} width={"100%"} /> */}
            </div>
            <div className='col-md-3 bxstv'>
              <h4 className='text-center fs-6'>Brand Wise Contribution</h4>
              <ReactApexChart options={donutOptions} series={donutvalues} type="pie" />
            </div>
            <div className='col-md-3 bxstv '>

              <GaugeComponent
                value={50}
                type="radial"
                labels={{
                  tickLabels: {
                    type: "inner",
                    ticks: [
                      { value: 20 },
                      { value: 40 },
                      { value: 60 },
                      { value: 80 },
                      { value: 100 }
                    ]
                  }
                }}
                arc={{
                  colorArray: ['#5BE12C', '#EA4228'],
                  subArcs: [{ limit: 10 }, { limit: 30 }, {}, {}, {}],
                  padding: 0.02,
                  width: 0.3
                }}
                pointer={{
                  elastic: true,
                  animationDelay: 0
                }}
              />
              {/* <DonutChart chartData={chartsData}/> */}

            </div>
          </div>
        </div>
      </div>
     
    </>
  );
};

export default Sales;
